import React from 'react';
import { getBugFeatureAttachmentUrl } from 'services/admin';
import useFileDownloader from 'hooks/useFileDownloader';

export default function BugFeatureAttachment({ attachment }) {
  const { loading, handleDownload } = useFileDownloader({
    file: attachment,
    getSignedUrl: getBugFeatureAttachmentUrl,
    queryKey: 'bugFeatrueAttachmentUrl',
  });

  return (
    <li>
      <a aria-disabled={loading} href="#" onClick={handleDownload}>
        {attachment.originalname}
      </a>
    </li>
  );
}
